if (!customElements.get('fluent-availability')) {
  customElements.define(
    'fluent-availability',
    class FluentAvailability extends HTMLElement {
      static observedAttributes = ['sku'];

      constructor() {
        super();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'sku') {
          this.sku = newValue;
        }
      }

      // Helper to get cookie value by name
      getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      }

      async extractTokenDataFromCookie() {
        const cookieValue = this.getCookie('__fcsession');
        if (!cookieValue) return null;
        try {
          const cookieObj = JSON.parse(decodeURIComponent(cookieValue));
          return cookieObj.fluentAccessTokenData || null;
        } catch {
          return null;
        }
      }

      async writeTokenDataToCookie(tokenData) {
        const cookieName = '__fcsession';
        const cookieValue = encodeURIComponent(
          JSON.stringify({
            fluentAccessTokenData: tokenData,
          })
        );
        const maxAge = tokenData.expiresIn;
        document.cookie = `${cookieName}=${cookieValue}; max-age=${maxAge}; path=/; SameSite=Lax`;
      }

      async fetchNewTokenData() {
        try {
          const response = await fetch('/apps/proxy/token', { method: 'GET' });
          if (!response.ok) throw new Error('Token fetch failed');
          const data = await response.json();
          return data || null;
        } catch (error) {
          console.error('Error fetching token:', error);
          return null;
        }
      }

      async getAuthTokenData() {
        let token = await this.extractTokenDataFromCookie();
        if (token) return token;
        const tokenData = await this.fetchNewTokenData();
        await this.writeTokenDataToCookie(tokenData);
        return tokenData;
      }

      async connectedCallback() {
        setTimeout(async () => {
          const skuRef = this.sku;

          const deliveryStatus = document.getElementById(`delivery-status-${skuRef}`);
          const collectionStatus = document.getElementById(`collection-status-${skuRef}`);

          if (!skuRef) return;

          try {
            const tokenData = await this.getAuthTokenData();
            const authToken = tokenData?.token;

            if (!authToken) {
              console.error('No auth token found');
              return;
            }

            const headers = {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authToken}`,
            };

            // Load Virtual Positions
            const virtualPositionQuery = `
              query ($catalogueRef: String!, $ref: String!) {
                virtualPosition(catalogue: {ref: $catalogueRef}, ref: $ref) {
                  id
                  ref
                  quantity
                }
              }
            `;

            const hdCatalogueRef = `ATS_HD:${tokenData.retailerId}`; // TODO: Should be from the cookie data
            const ccCatalogueRef = `ATS_CC:${tokenData.retailerId}`; // TODO: Should be from the cookie data
            const hdVariables = {
              catalogueRef: hdCatalogueRef,
              ref: `${skuRef}:${hdCatalogueRef}:AGGREGATE`,
            };

            const ccVariables = {
              catalogueRef: ccCatalogueRef,
              ref: `${skuRef}:${ccCatalogueRef}:AGGREGATE`,
            };

            // Fetch delivery availability
            fetch(`${tokenData.environmentURL}/graphql`, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({
                query: virtualPositionQuery,
                variables: hdVariables,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.data.virtualPosition?.quantity > 0) {
                  deliveryStatus.prepend(this.createDot('green'));
                  deliveryStatus.append(
                    this.createStatusDiv(`Available for Delivery (${data.data.virtualPosition.quantity})`)
                  );
                } else {
                  deliveryStatus.prepend(this.createDot('red'));
                  deliveryStatus.append(this.createStatusDiv('Not Available for Delivery'));
                }
              })
              .catch((err) => console.error('Delivery fetch error:', err));

            // Fetch collection availability
            fetch(`${tokenData.environmentURL}/graphql`, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({
                query: virtualPositionQuery,
                variables: ccVariables,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.data.virtualPosition?.quantity > 0) {
                  collectionStatus.prepend(this.createDot('green'));
                  collectionStatus.append(
                    this.createStatusDiv(`Available for Collection (${data.data.virtualPosition.quantity})`)
                  );
                } else {
                  collectionStatus.prepend(this.createDot('red'));
                  collectionStatus.append(this.createStatusDiv('Not Available for Collection'));
                }
              })
              .catch((err) => console.error('Collection fetch error:', err));
          } catch (err) {
            console.error('Error in connectedCallback:', err);
          }
        }, 0);
      }

      createDot(color) {
        // Create a span element for the dot
        const dot = document.createElement('span');

        // Apply styles to the dot
        dot.style.width = '10px';
        dot.style.height = '10px';
        dot.style.backgroundColor = color; // Change the color as needed
        dot.style.borderRadius = '50%';
        dot.style.display = 'inline-block';
        dot.style.marginRight = '10px'; // Space between the dot and the text

        return dot;
      }

      createStatusDiv(text) {
        const div = document.createElement('div');
        div.innerHTML = `<div>${text}</div>`;
        return div;
      }
    }
  );
}
